import { useState } from 'react';

const ADMIN_PASSWORD = 'GeoAdmin#2024';

interface AdminLoginProps {
  onSuccess: () => void;
}

export default function AdminLogin({ onSuccess }: AdminLoginProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      if (password === ADMIN_PASSWORD) {
        sessionStorage.setItem('nube_admin_auth', 'true');
        onSuccess();
      } else {
        setError('Contraseña incorrecta');
        setPassword('');
      }
      setLoading(false);
    }, 600);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: '#0D0F12' }}
    >
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-10">
          <div
            className="w-16 h-16 flex items-center justify-center rounded-2xl mx-auto mb-4"
            style={{ background: 'rgba(139,157,131,0.12)', border: '1px solid rgba(139,157,131,0.25)' }}
          >
            <i className="ri-shield-keyhole-line text-[#8B9D83] text-2xl" />
          </div>
          <h1 className="text-[#F8F6F3] font-semibold text-xl tracking-tight">Panel de Administración</h1>
          <p className="text-[#F8F6F3]/40 text-sm mt-1">Nube Geodésica — Acceso restringido</p>
        </div>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="rounded-2xl p-7 flex flex-col gap-5"
          style={{ background: 'rgba(248,246,243,0.04)', border: '1px solid rgba(248,246,243,0.08)' }}
        >
          <div className="flex flex-col gap-2">
            <label className="text-[#F8F6F3]/50 text-xs uppercase tracking-[2px]">Contraseña de administrador</label>
            <div className="relative">
              <input
                type={show ? 'text' : 'password'}
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                placeholder="••••••••••••"
                className="w-full px-4 py-3 rounded-xl text-sm text-[#F8F6F3] placeholder-[#F8F6F3]/20 outline-none transition-all duration-200 pr-12"
                style={{
                  background: 'rgba(248,246,243,0.06)',
                  border: `1px solid ${error ? 'rgba(201,123,99,0.5)' : 'rgba(248,246,243,0.10)'}`,
                }}
                autoFocus
              />
              <button
                type="button"
                onClick={() => setShow(!show)}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center cursor-pointer"
              >
                <i className={`${show ? 'ri-eye-off-line' : 'ri-eye-line'} text-[#F8F6F3]/30 text-sm`} />
              </button>
            </div>
            {error && (
              <p className="text-[#C97B63] text-xs flex items-center gap-1.5">
                <i className="ri-error-warning-line" /> {error}
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={!password || loading}
            className="w-full py-3 rounded-xl text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap disabled:opacity-40"
            style={{ background: 'rgba(139,157,131,0.90)', color: '#1A1C20' }}
          >
            {loading ? 'Verificando...' : 'Acceder al panel'}
          </button>
        </form>

        <p className="text-center text-[#F8F6F3]/20 text-xs mt-6">
          Acceso exclusivo para administradores del sistema
        </p>
      </div>
    </div>
  );
}
